<script>
export default {
  name: 'BubbleReactions',
  props: {
    reactions: {
      type: Array,
      default: () => [],
    },
    isTextOnly: {
      type: Boolean,
      default: false,
    },
    isOutgoing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    allSenders() {
      return this.reactions
        .flatMap(r => r.senders)
        .filter(s => s && !s.includes('(GROUP)'));
    },
    totalCount() {
      return this.reactions.reduce((sum, r) => sum + r.count, 0);
    },
  },
};
</script>

<template>
  <div
    class="absolute bottom-0 z-[1]"
    :class="isTextOnly ? (isOutgoing ? 'right-8' : 'right-3') : 'left-3'"
  >
    <div
      v-tooltip="allSenders.join(', ')"
      class="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full
             bg-white dark:bg-slate-700 shadow-sm border
             border-slate-100 dark:border-slate-800 text-sm cursor-default
             select-none"
    >
      <span v-for="reaction in reactions.slice(0, 5)" :key="reaction.emoji">
        {{ reaction.emoji }}
      </span>
      <span
        v-if="totalCount > 1"
        class="text-xs text-slate-500 dark:text-slate-300 font-medium"
      >
        {{ totalCount }}
      </span>
    </div>
  </div>
</template>
